export default __webpack_public_path__ + "static/media/header-bg.c78b82f6.webp";